"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[95],{

/***/ 2095:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_FooterBar; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-feather/dist/icons/chevron-up.js
var chevron_up = __webpack_require__(2802);
// EXTERNAL MODULE: ./components/ContentContainer.tsx
var ContentContainer = __webpack_require__(488);
;// CONCATENATED MODULE: ./components/GradientHeader.tsx


const GradientHeader = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
        className: "mt-4  bg-gradient-to-l from-brand-pink to-brand-turquoise  bg-clip-text font-mono text-xl  font-extrabold text-transparent text-white lg:mt-8 ",
        children: props.children
    });
};
/* harmony default export */ var components_GradientHeader = (GradientHeader);

// EXTERNAL MODULE: ./node_modules/react-intersection-observer/react-intersection-observer.modern.mjs
var react_intersection_observer_modern = __webpack_require__(7650);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/FooterBar.tsx







const FooterBar = ()=>{
    const socialsInView = (0,react_intersection_observer_modern/* useInView */.YD)({
        triggerOnce: true,
        rootMargin: "0px 0px"
    });
    const [isImprintOpen, setIsImprintOpen] = (0,react.useState)(false);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: socialsInView.ref,
        className: "flex flex-col items-center bg-brand-black text-white",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentContainer["default"], {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex h-full w-full  flex-col items-center text-center  justify-between py-8  pb-40 text-xs",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        "aria-label": "Show imprint",
                        onClick: ()=>setIsImprintOpen((prevState)=>!prevState),
                        className: "flex  flex-row pt-8  pb-8",
                        children: [
                            "Imprint & Privacy Policy",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chevron_up/* default */.Z, {
                                className: "-translate-y-1 transition-transform   duration-1000 " + (!isImprintOpen && "rotate-180")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col items-center  overflow-hidden  transition-[height] transition-transform duration-1000 " + (isImprintOpen ? "h-[1500px]  " : " h-[0px] "),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_GradientHeader, {
                                children: "Company"
                            }),
                            "Benjamin Thorstensen Bsc.",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "Laaer-Berg-Stra\xdfe 47/259 1100 Vienna, Austria",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_GradientHeader, {
                                children: "Contact"
                            }),
                            "+43 660 38 411 40",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "mailto:benjamin.thorstensen@scrumify.at",
                                className: "underline ",
                                children: "benjamin.thorstensen@scrumify.at"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_GradientHeader, {
                                children: "UID-Number"
                            }),
                            "ATU78136768",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "Member of the Vienna Chamber of Commerce (Wirtschaftskammer Wien)",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_GradientHeader, {
                                children: "Professional Law"
                            }),
                            "Commerce Order (Gewerbeordnung)",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "www.ris.bka.gv.at",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "Supervisory authority/commercial authority",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "Authority according to ECG (E-Commerce Act) Municipal District Office of the 10th District, MBA 10",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "Consumers have the possibility to submit complaints to the EU online dispute resolution platform: https://ec.europa.eu/odr",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "You can also send any complaints to the above e-mail address.",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_GradientHeader, {
                                children: "Liability for the content of this website"
                            }),
                            "I am constantly developing the content of this website and strive to provide correct and up-to-date information. Unfortunately, I cannot assume any liability for the correctness of all contents on this website, especially for those provided by third parties.",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "If you notice any problematic or illegal content, please contact me immediately at the email mentioned above!",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_GradientHeader, {
                                children: "Copyright notice"
                            }),
                            "All contents of this website (pictures, photos, texts, videos) are subject to copyright. If necessary, I will legally pursue the unauthorized use of parts of the content of my site.",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_GradientHeader, {
                                children: "Cookies"
                            }),
                            "This website does not use any cookies.",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_GradientHeader, {
                                children: "Pictures"
                            }),
                            "The pictures on this website were shot by",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                target: "_blank",
                                rel: "noreferrer",
                                href: "https://bulkin.photo/",
                                className: "  underline ",
                                children: "Yan Bululukov"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col space-y-8 mb-11",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-base font-semibold leading-7 text-primary mt-8 mb-1",
                                                children: "Further Services and Websites by me and my dear colleague Ren\xe9:"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "My part time Business where help companies accelerate their success."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                className: "text-primary underline",
                                                href: "https://www.kylo.at/",
                                                passHref: true,
                                                children: "kylo.at"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Your look. Your style. Your AI photos – simple and professional in just minutes!"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                className: "text-primary underline",
                                                href: "https://bildki.com/",
                                                passHref: true,
                                                children: "BILDKI.com"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "This Service built by my Partner Ren\xe9 and me, connects the best Software Engineers in Vienna with hand picked Companies."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                className: "text-primary underline",
                                                href: "https://juniornerd.at/",
                                                passHref: true,
                                                children: "juniornerd.at"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "Ren\xe9 is a passionate Software Engineer and website designer, check out his services."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                className: "text-primary underline",
                                                href: "https://webgaudi.at/",
                                                passHref: true,
                                                children: "webgaudi.at"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "This Band is fire, I built a website for them."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                className: "text-primary underline",
                                                href: "https://ardenite.net/",
                                                passHref: true,
                                                children: "ardenite.net"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: "You dont need to spend a fortune to get an Amazing Music Video. "
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                className: "text-primary underline",
                                                href: "https://ai.kylo.at/",
                                                passHref: true,
                                                children: "ai.kylo.at"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    "Copyright \xa9 ",
                    new Date().getFullYear(),
                    " Benjamin Thorstensen. All rights reserved."
                ]
            })
        })
    });
};
/* harmony default export */ var components_FooterBar = (FooterBar);


/***/ })

}]);